import dayjs from 'dayjs'
import { defineComponent, createApp, h } from 'vue';
import { ElImage, ElMessage } from 'element-plus';

import util from '@/api/util'
import { downloadBase64 } from "./base64";
import { randomString, generateSign } from "./sign";
import { gradeAppenObj, periodOfName } from '@/assets/json/types'
import { pinyin } from 'pinyin-pro';
import { cloneDeep } from 'lodash'
import { getCustomVal } from '@/util/customData.js'
import { marked } from 'marked'
import DOMPurify from 'dompurify'
import { getuserbindlistmsg } from '@/port/clientSide/multipleChoice.js'
import router from '../router';
const Base64 = require('js-base64').Base64

export const getOrgShowName = (data = {}, opt = {}) => {
  // 以后改了这个函数 要同步给后端
  let { name, type, looktype } = data
  const { isNeedType = true } = opt
  const typeObj = {
    7: true,
    8: true
  }
  if (typeObj[type] || !isNeedType) {
    // 不符合格式的全部都返回原来的名字
    if (isNeedType && ((type === 8 && !isStandardClass(name, 'class')) || (type === 7 && !isStandardClass(name, 'grade')))) return name
    if (!isNeedType && !isStandardClass(name, 'class') && !isStandardClass(name, 'grade')) return name
    const nameList = name.split('级')
    const grade = nameList[0] + '级'
    const cla = nameList[1]
    const gradeList = grade.split(/(\d+)/)
    // 年段  小学 初中 
    const yearPeriod = gradeList[0]
    const learnthe = dayjs().month() < 7 ? dayjs().year() - 1 : dayjs().year()
    // 入学年份  2023  2022
    const yearPeriodNum = Number(gradeList[1])
    const year = learnthe - yearPeriodNum
    const show = gradeAppenObj[yearPeriod][year]
    if (year < 0) {
      return name
    }
    if (!show && type === 7) {
      return name + '(已毕业)'
    }
    if (looktype === 2 && ['小学', '幼儿园', '高中'].includes(yearPeriod)) {
      looktype = 1
    }
    if (!isNeedType && name.includes('班')) {
      type = 8
    } else if (!isNeedType && !name.includes('班')) {
      type = 7
    }
    if (!show) return name
    if (type === 7) {
      // 年段
      if (looktype === 1) {
        return show
      } else if (looktype === 2) {
        return gradeAppenObj['特殊'][year]
      } else if (looktype === 3) {
        return periodOfName[yearPeriod][year]
      } else {
        return name
      }
    } else if (type === 8) {
      // 班级
      if (looktype === 1) {
        return show + cla
      } else if (looktype === 2) {
        return gradeAppenObj['特殊'][year] + cla
      } else if (looktype === 3) {
        return periodOfName[yearPeriod][year] + cla
      } else {
        return name
      }
    }
  } else {
    return name
  }
}
export function formatDate(date, fmt) {
  const flag = isTimeObject(date)
  if (!flag) date = new Date(date)
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + '';
      fmt = fmt ? fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str)) : str;
    }
  }
  return fmt;
}

function isTimeObject(value) {
  return value instanceof Date && !isNaN(value.getTime());
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length);
}

export const isStandardClass = (str, type) => {
  const classregx = /(幼儿园|小学|初中|高中)(\d+)(级)(\d+)(班)/
  const graderegx = /(幼儿园|小学|初中|高中)(\d+)(级)/
  if (type === 'class') {
    return classregx.test(str)
  } else if (type === 'grade') {
    return graderegx.test(str)
  } else {
    return false
  }
}

//附件预览
export function filePreview(item, down, isEdit) {
  //如果是下载，down为true
  //如果是编辑，isEdit为true
  item = JSON.parse(JSON.stringify(item))
  item.url = item.url || item.response
  console.log("item==", item);
  // 对文件名的特殊字符转码
  let tempUrlList = item.url.split('/')
  let tempUrl = tempUrlList[tempUrlList.length - 1].split('.')
  // 文件类型
  let fileType = tempUrl.pop()
  // 文件名字
  let fileName = tempUrlList[tempUrlList.length - 1]
  // let fileName = tempUrl[0]
  tempUrlList[tempUrlList.length - 1] = tempUrl.join('.') + '.' + fileType

  item.url = tempUrlList.join('/')
  console.log(item.url);
  if (!item.url) { // 如果没有路径，就是错误
    return false
  }
  let urls = item.url.indexOf("http") > -1 ? item.url : util.apiUrl() + item.url
  // 如果有登录的情况下就把所有的confiles转换为userfiles 未登录能触发下载就说明是开放的数据源 就把userfiles转为confiles
  if (localStorage.getItem('user')) {
    urls = urls.replace('/confiles/', '/userfiles/')
    urls = urls.indexOf('?accesstoken') === -1 && urls.indexOf('/userfiles/') > -1 ? urls + '?accesstoken=' + filesConfig() : urls
  } else {
    urls = confilesRes(urls)
  }
  console.log("urls==", urls, item.url);
  if (down) {
    if (item.signet && !item.signet.isRejectSign) { // 签署过，并且不是作废文件
      const randomStr = randomString(32)
      let param = {
        appid: '8b9d8429c1bc11e9aea654e1ad008634',
        id: item.signet,
        nonce_str: randomStr,
      }
      const key = '911a4818c1bc11e9aea654e1ad008634'
      const sign = generateSign(param, key)
      // parent.location.href = 'http://139.9.73.65:8888/api/v1/contract/downdocument/'+item.signet.docId
      parent.location.href = 'https://ca.topeti.com/service/api/dl?appid=8b9d8429c1bc11e9aea654e1ad008634&id=' + item.signet + '&nonce_str=' + randomStr + '&sign=' + sign
    } else {
      if (/\.(png|jpg|jpeg|gif|GIF|PNG|JPG|JPEG)$/.test(urls)) {
        // 图片的下载方式
        downloadImage(urls, fileName, fileType)
      } else {
        const downFile = document.createElement('a')
        downFile.style.display = 'none'
        downFile.href = urls
        downFile.download = fileName // 下载后文件名
        document.body.appendChild(downFile)
        downFile.click()
        document.body.removeChild(downFile)
        // parent.location.href = urls
      }
    }
  } else {
    if (/\.(xlsx|xls|doc|docx|ppt|pptx|pdf|PDF|txt|wps|et|ett|pot|pps|dps|dpt|XLSX|DOC|XLS|DOCX|PPTX|PPT|zip|ZIP|rar|RAR)$/.test(item.url)) {
      let apiurl = util.apiUrl()
      const host = document.domain
      // 英才如果通过www.xmycxx.com预览pdf文件，需要修改url地址
      if (apiurl == "https://zhihui.xmycxx.com" && host == 'www.xmycxx.com') {
        urls = urls.replace(apiurl, "https://www.xmycxx.com");
      }
      // pdf换成本地预览
      if (fileType === 'pdf') {
        // pdf不需要传token
        // if (urls.includes('?accesstoken=')) {
        //   urls = urls.substring(0, urls.indexOf('?accesstoken='))
        // }
        const routeUrl = router.resolve({
          path: '/previewFile',
          query: {
            url: urls
          }
        })
        window.open(routeUrl.href, '_blank')
        return false;
      }
      // 预览的时候，吧userfiles转成confiles，防止转码得不到
      // 判断如果是国贸域名，则修改成外网可访问的域名
      if (apiurl == "http://app.itgedu.com.cn" || apiurl == "http://10.66.99.244" || apiurl == "http://10.66.99.244:8088") {
        urls = urls.replace(apiurl, "https://admin.itgedu.com.cn:6352");
      }
      // 判断如果是厦大学情域名，则修改成外网可访问的域名
      else if (apiurl == "http://idata.xmu.edu.cn" || apiurl == "https://idata.xmu.edu.cn") {
        urls = urls.replace(apiurl, "https://idatah5.xmu.edu.cn");
      }
      if (isEdit) {
        // 编辑文件
        if (/\.(xlsx|xls|docx|ppt|pptx|txt|XLSX|XLS|DOCX|PPTX|PPT)$/.test(item.url)) {
          const newUrl = item.url.indexOf("http") > -1 ? item.url : apiurl + item.url
          const editSrc = `${apiurl}/cust/document/?src=${newUrl}&accesstoken=${filesConfig()}&upload=${apiurl}/api/updatefile`
          window.open(editSrc)
        } else {
          ElMessage({ type: 'warning', message: '该文件格式不支持在线编辑' })
        }
        return false
      }
      if (navigator.userAgent) {
        urls += `&userAgent=${encodeURIComponent(navigator.userAgent)}`
      }
      urls = Base64.encode(urls)
      console.log("urls==", urls);
      // 判断如果是龙岩教育局域名，则用龙岩教育局的附件预览地址，其余统一用阿里的预览地址
      if (apiurl == "https://wskjzs.longyanedu.net") {
        window.open('https://wskjzs.longyanedu.net/previewfile/onlinePreview?url=' + urls)
      } else if (apiurl === 'https://guanli.xmjmedu.com' || apiurl === 'https://www.xmjmedu.com') {
        window.open('https://guanli.xmjmedu.com/previewfile/onlinePreview?url=' + urls)
      } else if (apiurl === 'https://zhihui.xmycxx.com' || apiurl === 'https://www.xmycxx.com') {
        window.open('https://zhihui.xmycxx.com/previewfile/onlinePreview?url=' + urls)
      } else {
        window.open('https://user.topeti.com/previewfile/onlinePreview?url=' + urls)
      }
    }
    else if (/\.(png|jpg|jpeg|gif|GIF|PNG|JPG|JPEG)$/.test(item.url)) {
      // 预览图片格式的文件
      // 暂时先不处理
      showImagePreview(urls)
      // window.open('').document.write(`<!DOCTYPE html><html><body ><img style="width: 100%;" src='${urls}'/></body></html>`)
    }
    else if (/\.(mp4)$/.test(item.url)) {
      // 预览视频格式的文件 暂不支持avi|wmv|mpg|mpeg|mov|rm|ram|swf|flv|
      window.open('').document.write(`<!DOCTYPE html><html><body><div style="display:flex;height:650px;justify-content: center;align-items: center;"><video controls height="100%" src="${urls}">您的浏览器不支持 HTML5 video 标签。</video></div></body></html>`)
    } else if (/\.(html?|xhtml)$/i.test(item.url)) {
      // 移除URL中的参数部分
      const cleanUrl = urls.split('?')[0];
      // 替换userfiles为previewfiles
      const targetUrl = cleanUrl.replace('userfiles', 'previewfiles');
      window.open(targetUrl, '_blank');
    } else {
      window.open('').document.write(`<!DOCTYPE html><html><body>该格式不支持预览</body>`)
      // window.open(urls)
    }
  }
}

export function confilesRes(val) { // item有值，就是改格式，key0就是userfiles key有值就是confiles,item没值就是获取token
  return val.replace('/userfiles/', '/confiles/')
}


export function filesConfig(item, key) { // item有值，就是改格式，key0就是userfiles key有值就是confiles,item没值就是获取token
  if (item) {
    return item.indexOf('confiles/') > -1 || item.indexOf('userfiles/') > -1 ? item : key ? '/confiles/' + item : '/userfiles/' + item
  } else {
    return JSON.parse(localStorage.getItem('user')).accesstoken
  }
}

function downloadImage(imgsrc, name, type = 'png') {
  let image = new Image();
  // 解决跨域 Canvas 污染问题
  image.setAttribute("crossOrigin", "anonymous");
  image.onload = function () {
    let canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;
    let context = canvas.getContext("2d");
    context.drawImage(image, 0, 0, image.width, image.height);
    let url = canvas.toDataURL(`image/${type}`); //得到图片的base64编码数据
    let a = document.createElement("a"); // 生成一个a元素
    let event = new MouseEvent("click"); // 创建一个单击事件
    a.download = name || "pic"; // 设置图片名称
    a.href = url; // 将生成的URL设置为a.href属性
    a.dispatchEvent(event); // 触发a的单击事件
  }
  //将资源链接赋值过去，才能触发image.onload 事件
  image.src = imgsrc
}

export function fileFormatted(name, key) {
  let site = name.lastIndexOf(".");
  let format = name.substring(site + 1, name.length);
  format = format.toLocaleLowerCase()
  if (key && key === 'music') {
    // 音乐格式判断
    return format === 'mp3' || format === 'aac' || format === 'flac' || format === 'MP3' || format === 'AAC' || format === 'FLAC' || format === 'm4a' || format === 'M4A'
  } else if (key && key === 'video') {
    // 视频格式的判断
    const videoFormat = ['mp4', 'avi', 'flv', 'wmv']
    return videoFormat.includes(format)
  } else if (key && key === 'html') {
    // html格式的判断
    const htmlFormat = ['html','htm','xhtml']
    return htmlFormat.includes(format)
  }
  if (format == 'jpeg' || format == 'jpg' || format == 'tiff' || format == 'psd' || format == 'png' || format == 'bmp' || format == 'gif' || format == 'doc'
    || format == 'docx' || format == 'xls' || format == 'xlsx' || format == 'txt' || format == 'pdf' || format == 'ppt' || format == 'pptx' || format == 'rar'
    || format == 'zip' || format == 'wps' || format == 'et' || format == 'ett' || format == 'pot' || format == 'pps' || format == 'dps' || format == 'dpt' || format == 'dw' || format == 'dc' || format == 'tif' || format == 'gd' || format == 'GD' || format == 'gw' || format == 'GW' || format == 'mp4' || format == 'avi' || format == 'mpg' || format == 'mpeg' || format == 'mov' || format == 'rm' || format == 'ram' || format == 'swf' || format == 'flv' || format == 'mp3' || format == 'wmv') {
    return true
  } else {
    return false
  }
}

// 时间差 airTimeKey 开始时间；endTimeKey 结束时间 calculation 0天，1小时，2分钟，3月份，4年份  digital：0取整四舍五入，1取整，2保留小数点一位，3保留小数点两位
export function onTimeDifference(airTimeKey, endTimeKey, calculation, digital) {
  let airTimeStr = Date.parse(airTimeKey)
  let endTimeStr = Date.parse(endTimeKey)
  if (airTimeStr && endTimeStr) {
    let second = endTimeStr - airTimeStr
    // 分钟
    var min = Math.floor(second / 1000 / 60)
    // 小时
    var hr = min / 60
    // 天数
    var day = hr / 24
    // 计算月份差
    var month = calculateMonthDifference(airTimeKey, endTimeKey)
    // 计算年份差
    var year = calculateYearDifference(airTimeKey, endTimeKey)
    
    // 根据calculation参数返回对应的时间单位
    switch(calculation) {
      case 1: return mathdigital(hr, digital)      // 小时
      case 2: return mathdigital(min, digital)     // 分钟
      case 3: return mathdigital(month, digital)   // 月份
      case 4: return mathdigital(year, digital)    // 年份
      default: return mathdigital(day, digital)    // 天数（默认）
    }
  } else {
    return 0
  }
}
// 计算月份差
function calculateMonthDifference(startTime, endTime) {
  const start = new Date(startTime)
  const end = new Date(endTime)
  const startYear = start.getFullYear()
  const startMonth = start.getMonth()
  const endYear = end.getFullYear()
  const endMonth = end.getMonth()
  // 计算总月份差
  const totalMonths = (endYear - startYear) * 12 + (endMonth - startMonth)
  // 考虑天数差异，如果结束日期的天数小于开始日期的天数，则月份减1
  const startDay = start.getDate()
  const endDay = end.getDate()
  if (endDay < startDay) {
    return totalMonths - 1
  }
  return totalMonths
}

// 计算年份差
function calculateYearDifference(startTime, endTime) {
  const start = new Date(startTime)
  const end = new Date(endTime)
  
  // 计算总毫秒差
  const timeDiff = end.getTime() - start.getTime()
  
  // 转换为年份（1年 = 365.25天 = 365.25 * 24 * 60 * 60 * 1000毫秒）
  const yearDiff = timeDiff / (365.25 * 24 * 60 * 60 * 1000)
  
  return yearDiff
}
function mathdigital(val, key) {
  console.log("val==",val);
  
  // key：0取整四舍五入，1取整，2保留小数点一位，3保留小数点两位
  return key === 1 ? Math.trunc(val) : key === 2 ? val.toFixed(1) : key === 3 ? val.toFixed(2) : Math.round(val)
}

/**
 * 
 * @param {string} str 符合字符串标准的班级格式
 * @param {string} info 需要获取的班级信息  格式为 **+**
 * @returns {string}返回一个字符串
 */
export const getClassInfo = (str, info = '', looktype = 0) => {
  if (!isStandardClass(str, 'class') || !str) return ''
  if (!info) return str
  const nameList = str.split('级')
  const grade = nameList[0] + '级'
  const gradeList = grade.split(/(\d+)/)
  // 学段  小学 初中 
  const academicStageInfo = gradeList[0]
  if (looktype === 2 && ['小学', '幼儿园', '高中'].includes(academicStageInfo)) {
    looktype = 1
  }
  // 年段  初一 初二 一年级 二年级
  const learnthe = dayjs().month() < 7 ? dayjs().year() - 1 : dayjs().year()
  const year = learnthe - Number(gradeList[1])
  let yearPeriodInfo = ''
  if (looktype === 1) {
    yearPeriodInfo = gradeAppenObj[academicStageInfo][year]
  } else if (looktype === 2) {
    yearPeriodInfo = gradeAppenObj['特殊'][year]
  } else {
    yearPeriodInfo = gradeList[1] + '级'
  }
  if (!yearPeriodInfo) {
    yearPeriodInfo = gradeList[1] + '级'
  }
  // 年级
  const gradeInfo = Number(gradeList[1]) + '级'
  // 班级
  const classInfo = nameList[1]
  const classInfoObj = {
    学段: academicStageInfo,
    年段: yearPeriodInfo,
    年级: gradeInfo,
    班级: classInfo,
  }
  let res = ''
  const data = info.split('+')
  for (const item of data) {
    res += classInfoObj[item]
  }
  return res
}

//时间解析
export function timeFormatDate(date) {
  let val = typeof date === 'number' ? new Date(date) : new Date(Number(date))
  let data = [val.getFullYear(), val.getMonth() + 1, val.getDate()]
  return data.join('-')
}

export function fileListForeach(ArrVal) {
  ArrVal.forEach(item => {
    item.response = filesConfig(item.response)
  })
  return ArrVal
}

/**
 * 联动条件数据获取,提交给后台用
 * dataconfig当前控件联动配置信息，formdata数据源，dataset当前控件key值dataset.types=details为大明细联动，false为其他联动，batch是否批量处理 customData为应用的变量
 */
export function linkedSetEvent(dataconfig, formdata, dataset, batch, customData = []) {
  const _dataconfig = cloneDeep(dataconfig)
  // 处理一下过滤时候使用到的变量
  if (_dataconfig.filter && _dataconfig.filter.where && _dataconfig.filter.where.length > 0) {
    _dataconfig.filter.where = _dataconfig.filter.where.map(item => {
      if (item.value && Array.isArray(item.value) && item.value.length > 0) {
        const valueArr = []
        item.value.forEach(val => {
          // 存在变量
          if (typeof val === 'string' && val.search('{') !== -1 && customData.length > 0) {
            const match = val.match(/\{(.*?)\}/)
            const name = match[1]
            let value = getCustomVal({name}, customData)
            // 如果变量又多个值那就得都加进去
            if (Array.isArray(value)) {
              if (value[0] && value[0].userId) {
                // 存在userId就是用户 联动这边的用户都是传姓名的
                value = value.map(item => { return item.realname })
              }
              valueArr.push(...value)
            } else {
              valueArr.push(value)
            }
          } else {
            // 普通的值
            valueArr.push(val)
          }
        })
        item.value = valueArr
      } 
      return item
    })
  }
  let param = {};
  param.types = dataset ? dataset.types : false
  param.dataconfig = JSON.stringify(_dataconfig);
  if (batch && dataconfig.linked && dataconfig.linked.conditional && dataconfig.linked.conditional.length > 0) { param.batch = true }//如果是明细批量的话。就走这个（无条件联动情况下，不加batch）
  if (dataconfig.linked && dataconfig.linked.conditional) {
    for (let ez of dataconfig.linked.conditional) {
      let value = "";
      if (ez.feild.indexOf("details.") != -1) {//包含
        let details = ez.feild.split(".")[0];
        let item = ez.feild.split(".")[1];
        if (batch) {
          value = formdata[details].map(officer => officer[item] || '');
          value = JSON.stringify(value)
        } else {
          value = formdata[details][dataset.index][item]
        }
      } else if (ez.feild == "表单发起人_relation-user") {
        value = '表单发起人'
      } else if (ez.feild == "当前用户_relation-user") {
        value = '当前用户'
      } else {
        value = formdata[ez.feild]
      }
      if (!value || value.length == 0 || value == '[]') {
        param = false;
        break;
      }
      param[ez.feild] = value instanceof Array ? JSON.stringify(value) : value
    }
  }
  return param;
}

function showImagePreview(imageUrl) {
  // 创建隐藏图片元素（保持原有逻辑）
  const img = document.createElement('img');
  img.src = imageUrl;
  img.style.display = 'none';
  
  document.body.appendChild(img);

  // 创建组件定义
  const ImageComponent = defineComponent({
    setup() {
      return () => h(ElImage, {
        src: imageUrl,
        previewSrcList: [imageUrl],
        hideOnClickModal: true,
        // Vue3 事件监听直接绑定
        onClose: () => {
          document.body.removeChild(container);
          document.body.removeChild(img);
        }
      });
    }
  });

  // 创建挂载容器
  const container = document.createElement('div');
  document.body.appendChild(container);

  // 创建应用实例并挂载
  const app = createApp(ImageComponent);
  app.mount(container);

  // 手动触发预览（Element Plus API）
  setTimeout(() => {
    const imageInstance = container.querySelector('.el-image__inner');
    if (imageInstance) {
      imageInstance.click();
    }
  }, 100);
}

export function sliceEncrypt(str, encrypt) {
  return encrypt && str && str.length > 6 ? '******' + str.slice(str.length - 6, str.length) : str
}

export const getSwitchColor = (opt = {}) => {
  const { ele, type, isGet = false } = opt
  const obj = {
    'active': 0,
    'inactive': 1
  }
  let item = null
  // 由于ele的不同，需要在这边判断一下去哪里取值
  if (ele.options && ele.options.options && Array.isArray(ele.options.options)) {
    item = ele.options.options[obj[type]]
  } else if (ele.sels && Array.isArray(ele.sels)) {
    item = ele.sels[obj[type]]
  }
  if (isGet && item) {
    return item.value
  }
  if (item && ele.selsItemColor) {
    return ele.selsItemColor[item.value]
  }
}

//markdown转文本格式
export const markdownToText = (val) => {
  // 非富文本控件，去除markdown格式，转换为纯文本
  val = val
  // 移除代码块
  .replace(/```[\s\S]*?```/g, '')
  // 移除行内代码
  .replace(/`([^`]+)`/g, '$1')
  // 移除标题
  .replace(/#{1,6}\s+/g, '')
  // 移除粗体和斜体
  .replace(/[*_]{1,2}([^*_]+)[*_]{1,2}/g, '$1')
  // 移除链接
  // eslint-disable-next-line no-useless-escape
  .replace(/\[([^\]]+)\]\([^\)]+\)/g, '$1')
  // 移除列表标记
  .replace(/^[-*+]\s+/gm, '')
  .replace(/^\d+\.\s+/gm, '')
  // 移除引用
  .replace(/^>\s+/gm, '')
  // 移除表格格式
  .replace(/\|.*\|/g, '')
  // 移除多余空行
  .replace(/\n{3,}/g, '\n\n')
  // 移除HTML标签
  .replace(/<[^>]+>/g, '')
  // 修整空白字符
  .trim();
  return val
}

//markdown转html格式
export const markdownToHtml = (val) => {
  // 配置marked选项
  marked.setOptions({
    gfm: true, // 启用GitHub风格的markdown
    breaks: true, // 启用回车换行
    headerIds: false, // 禁用标题ID
    mangle: false, // 禁用转义
    sanitize: false // 禁用内置的sanitize
  });

  // 将markdown转换为HTML并进行安全处理
  val = DOMPurify.sanitize(marked.parse(val), {
    ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 
                'ul', 'ol', 'li', 'code', 'pre', 'blockquote', 'a', 'table', 'thead', 
                'tbody', 'tr', 'th', 'td'],
    ALLOWED_ATTR: ['href', 'target', 'rel']
  });
  return val
}

/**
 * 联动返回数据，做个验证，如果联系人格式的回填不是联系人格式的，要做个处理
 * res格式不能为[[]],嵌套数组
 */
export function linkedFormatConversion(item, res) {
  if (item.type === "relation-user") {
    if (item.dataconfig && item.dataconfig.setUpValue == 3) {//选项联动
      let value = []
      res.forEach(e => {
        value = value.concat(e)
      });
      return value
    } else {
      return res[0]
    }
  } else if (item.type === "details") {
    return res
  } else {
    if (res && res[0] && (res[0].userId || res[0][0] && res[0][0].userId)) {
      res[0] = ""
    }
    return item.type === "checkbox" || item.type === "radio" ? res : res[0]
  }
}

export const getPinyin = (value) => {
  if (!value) return value
  if (!hasChinese(value)) return value
  // 获取中文首字母
  return pinyin(value, { pattern: 'first', type: 'array' }).join('')
}

function hasChinese(str) {
  return /[\u4e00-\u9fff\u3400-\u4dbf\u20000-\u2a6df\u2a700-\u2b73f\u2b740-\u2b81f\u2b820-\u2ceaf\uf900-\ufaff\u3300-\u33ff\u2e80-\u2eff\u31c0-\u31ef\u2ff0-\u2fff]/.test(str);
}

// 数组
// datalist 数组列表 mode求值方式 0：求和，1：求平均，2：求最大，3：求最小，digital（onTimeDifference）此方法已备注
export function onDigitCount(datalist, item, config) {
  let key = item.title + '_' + item.type //
  let mode = config.dataconfig.formula.calculation
  let digital = config.dataconfig.formula.digital
  datalist = [...datalist]
  let valNum = ""
  datalist.forEach(ele => {
    ele[key] = Number(ele[key]) || 0
    if (mode === 2) {
      // 求最大值
      valNum = valNum === '' ? ele[key] : valNum > ele[key] ? valNum : ele[key]
    } else if (mode === 3) {
      // 求最小值
      valNum = valNum === '' ? ele[key] : valNum > ele[key] ? ele[key] : valNum
    } else {
      // 求和 或者求平均
      valNum = valNum === '' ? ele[key] : valNum + ele[key]
    }
  })
  valNum = mode === 1 ? valNum / (datalist.length) : valNum
  return mathdigital(valNum, digital)
}

/**
 * 配置了联动，判断是否有关系判断是否有关系
 */
export function onIsinclude(dataconfig, item) {
  let key = -1;
  if (dataconfig.linked.conditional && dataconfig.linked.conditional.length > 0) {
    key = dataconfig.linked.conditional.findIndex(e => {
      return item.title + '_' + item.type == e.feild || item.title + '_' + item.type == e.feild.split(".")[1]
    })
  }
  return key;
}

/**
 * linkedDetailsKeyMap处理大明细返回数据格式转换
 */
export function linkedDetailsKeyMap(res) {
  let keyMap = {};
  Object.keys(res[0]).forEach(e => {
    keyMap[e] = e.split(".")[1]
  })
  return res.map(item => {
    return Object.keys(item).reduce((newData, key) => {
      let newKey = keyMap[key] || key
      // newData[newKey] = newKey.split("_")[1]=='checkbox'?[]:newKey.split("_")[1]=='radio'?'':item[key]//不需要回填多选和单选
      newData[newKey] = item[key]//需要回填多选和单选
      return newData
    }, {})
  })
}
export function logobase64() {
  const userMsg = localStorage.getItem("userMsg") ? JSON.parse(localStorage.getItem("userMsg")) : {}
  let url = util.apiUrl() + userMsg.schoolMsg.photo
  return downloadBase64(url).then(res => {
    return res[0]
  })
}
/**
 * 附件通过路径获取名字
 */
export function BatchFileName(url) {
  let name = url.split('/')[url.split('/').length - 1]
  return name.slice(15, name.length)
}

//头像格式化，如果没有头像，显示名字，有头像显示头像
export const headconver = (baseinfo) => {
  if (baseinfo && baseinfo != null) {
    var realname;
    if (baseinfo.realname) {
      realname = (baseinfo.realname).substring((baseinfo.realname).length - 2);
    } else if (baseinfo.name) {
      realname = (baseinfo.name).substring((baseinfo.name).length - 2);
    }
    if (!baseinfo.logo && baseinfo.avatar) {
      baseinfo.logo = baseinfo.avatar;
    }
    return +!baseinfo.logo || baseinfo.logo == '' ? "<p style=''>" + realname + "</p>" : "<img src=" + util.apiUrl() + baseinfo.logo + "  width='100%' />"
  }
};

export const converDataLast = (value) => {//len为后面几位
  if (value && value != null) {//如果有数据
    return (value.name).substring((value.name).length - value.len);
  }
};


export async function getUserCheck(list, data) {
  const li = []
  let moreInfoArr = []
  const resUser = { checkedUserArr: JSON.parse(JSON.stringify(list)) }
  if (data.isMoreInfo && data.moreInfoArr.length > 0) { // 是否提交用户更多的信息
    moreInfoArr = data.moreInfoArr
  }
  if (list.length > 0 && moreInfoArr.findIndex(item => { return item.search('部门：') !== -1 }) !== -1) {
    const userIds = resUser.checkedUserArr.map(item => { return item.userId })
    const { code, data } = await getuserbindlistmsg({ userIds: userIds.join(',') })
    if (code === 0) {
      resUser.checkedUserArr = data
    }
  }
  resUser.checkedUserArr.forEach(el => {
    let elObj = {
      realname: el.realname,
      userId: el.userId
    };
    // 如果有组织信息
    if (el.orgname || el['部门']) elObj.orgname = el.orgname || el['部门']
    if (el.orglst) elObj.orglst = el.orglst
    moreInfoArr.forEach(key => {
      if (elObj[key] === undefined && el[key] !== undefined) {
        if (key === 'phone') { // 手机的话把真实手机号也提交上来
          elObj.realphone = el.realphone
        } else if (key === 'type') {
          elObj.userTip = resUser.userLabel ? resUser.userLabel[el[key]] : {}
        }
        elObj[key] = el[key]
      }
    })
    li.push(elObj);
  })
  return li
}